<div class="row justify-content-around py-5">
    <div class="col-auto">
        <div class="spinner-grow spinner-grow-sm loading-spinner1" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    <div class="col-auto">
        <div class="spinner-grow spinner-grow-sm loading-spinner2" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    <div class="col-auto">
        <div class="spinner-grow spinner-grow-sm loading-spinner3" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    <div class="col-auto">
        <div class="spinner-grow spinner-grow-sm loading-spinner4" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
    <div class="col-auto">
        <div class="spinner-grow spinner-grow-sm loading-spinner5" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div>